import { createClient, type SupabaseClient } from "@supabase/supabase-js";

export function createBrowserClient(
  url: string,
  anonKey: string
): SupabaseClient {
  return createClient(url, anonKey);
}
